import { useRef } from 'react'

import { EMPTY_STRING } from '../../../../constants/common'
import { WYSIWYG_EDITOR_EVENT_PASTE_PRE_PROCESS } from '../../WysiwygEditor.constants'

import { hasTable } from './useEditorTablePasteRestriction.utils'

export function useEditorTablePasteRestriction({ enableTables }) {
  const editorRef = useRef(null)

  function handlePastePreProcess(e) {
    if (enableTables) {
      const editor = editorRef.current

      const html = e?.content

      const selectionNode = editor?.selection?.getNode?.()

      if (editor && html && hasTable(html) && selectionNode) {
        const isInsideCell = selectionNode?.closest
          ? Boolean(selectionNode.closest('td, th'))
          : Boolean(editor?.dom?.getParent?.(selectionNode, 'td,th'))

        // Prevent inserting tables into existing table cells
        if (isInsideCell) {
          const tmp = document.createElement('div')

          tmp.innerHTML = html

          const text = tmp.textContent || EMPTY_STRING
          const encoded = editor.dom.encode(text)

          e.content = encoded.replace(/\r?\n/g, '<br />')
        }
      }
    }
  }

  function setup(editor) {
    if (enableTables) {
      editorRef.current = editor

      editor.off?.(
        WYSIWYG_EDITOR_EVENT_PASTE_PRE_PROCESS,
        handlePastePreProcess
      )
      editor.on?.(WYSIWYG_EDITOR_EVENT_PASTE_PRE_PROCESS, handlePastePreProcess)
    }
  }

  return {
    setup,
  }
}
